import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import { KeyValueResponse } from '../../../../model';
import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { PaginatedData } from '../../../../../models/List';
import {
  AppealSummaryResponse,
  ResultsAppealExportResponse,
  ResultsAppealFunctionRequest,
  ResultsAppealSearchRequest,
  ResultsAppealSearchResponse,
} from '../../model';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 30000;

export const opsAdminAppealClient = axiosFactory(baseURL, timeout);

/** to get candidate types
 * */
export const getCandidateTypes = () =>
  opsAdminAppealClient.get<KeyValueResponse[]>(`${ROUTES.GET_CANDIDATE_TYPES}`);

/** to get candidate types
 * */
export const getNationalExamLevels = () =>
  opsAdminAppealClient.get<KeyValueResponse[]>(`${ROUTES.GET_NATIONAL_EXAM_LEVELS}`);

/** Search the results appeal */
export const postRawResultsAppealSearch = (
  csrfToken: string,
  data: ResultsAppealSearchRequest,
  paging: ApiPathParam
) =>
  opsAdminAppealClient.post<PaginatedData<ResultsAppealSearchResponse>>(
    csrfToken,
    ROUTES.POST_RAW_RESULTS_APPEAL_SEARCH(paging),
    data
  );

/** Export the results appeal */
export const postResultsAppealExportExcel = (
  csrfToken: string,
  data: ResultsAppealFunctionRequest
) =>
  opsAdminAppealClient.post<ResultsAppealExportResponse>(
    csrfToken,
    ROUTES.POST_RESULTS_APPEAL_EXPORT_EXCEL,
    data
  );

/** Get the results appeal details */
export const getResultsAppealDetails = (uuid: string) =>
  opsAdminAppealClient.get<AppealSummaryResponse>(`${ROUTES.GET_RESULTS_APPEAL_DETAIL}/${uuid}`);
